import {createSvgIcon} from '../create-svg-icon';

export const SignalCellularAltIcon = createSvgIcon(
  <path d="M17 4h3v16h-3V4zM5 14h3v6H5v-6zm6-5h3v11h-3V9z" />
, 'SignalCellularAltOutlined');
